module.exports = __webpack_public_path__ + "static/media/SmartRecipez.ba6293d0.png";